module.exports = __webpack_public_path__ + "img/image-2.ab71a7d4.png";